const semanticClassNames = {
  root: 'lightbox',
} as const;

export default semanticClassNames;
